<template>
  <div class="solutions">
    <!-- 顶部标题区域-->
    <section class="products-header solutions-header">
      <div class="container">
        <h1 class="page-title">
          <span class="title-glow">IT业务</span>
        </h1>
        <p class="page-subtitle">专业服务 · 集成服务 · 运营服务</p>
      </div>
    </section>

    <!-- 内容区域 -->
    <section class="content-section">
      <div class="container">
        <div v-if="loading" class="loading-container">
          <p>加载中...</p>
        </div>
        <div v-else-if="error" class="error-container">
          <p>{{ error }}</p>
        </div>
        <div v-else class="tab-panel">
          <div
            v-for="(section, sIndex) in itSections"
            :key="section.title"
            class="it-section"
          >
            <h2
              class="it-section-title"
              :class="{ 'it-section-title--sub': sIndex > 0 }"
            >
              {{ section.title }}
            </h2>
            <div
              class="services-list"
              :class="section.items.length > 2 ? 'services-list--three' : 'services-list--two'"
            >
              <div
                v-for="(item, index) in section.items"
                :key="index"
                class="it-card"
                @click="goToDetail(item)"
              >
                <div
                  class="it-card-image"
                  :style="{ backgroundImage: `url(${resolveSectionImage(item.image)})` }"
                ></div>
                <div class="it-card-body">
                  <h3 class="it-card-title">{{ item.title }}</h3>
                  <p class="it-card-desc">{{ item.description }}</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
import axios from 'axios'

// 使用 require.context 让 webpack 在打包时收集 IT 列表图片资源
const itSectionImageCtx = require.context('@/assets/it/img_home', false, /\.(png|jpe?g)$/)

export default {
  name: 'ITSolutions',
  data() {
    return {
      itSections: [],
      loading: false,
      error: null
    }
  },
  async mounted() {
    await this.fetchSections()
  },
  methods: {
    async fetchSections() {
      try {
        this.loading = true
        this.error = null
        const response = await axios.get('/api/it/sections')
        if (response.data.code === 200) {
          this.itSections = Array.isArray(response.data.data) ? response.data.data : []
        } else {
          this.error = response.data.message || '获取IT业务数据失败'
          this.itSections = []
        }
      } catch (error) {
        console.error('获取IT业务数据失败:', error)
        this.error = '网络请求失败，请检查服务器是否运行'
        this.itSections = []
      } finally {
        this.loading = false
      }
    },
    goToDetail(item) {
      if (item && item.id) {
        this.$router.push({
          path: '/it/detail',
          query: {
            id: item.id
          }
        })
      } else {
        console.warn('IT业务项缺少ID，无法跳转到详情页', item)
      }
    },
    resolveSectionImage(imagePath) {
      if (!imagePath) return ''
      // JSON 中配置的是 "@it_img_home/filename"
      if (imagePath.startsWith('@it_img_home/')) {
        const fileName = imagePath.replace('@it_img_home/', '')
        try {
          return itSectionImageCtx('./' + fileName)
        } catch (e) {
          console.warn('IT 列表图片未找到:', fileName, e)
          return ''
        }
      }
      // 其他情况直接返回原路径（例如外部 URL）
      return imagePath
    }
  }
}
</script>

<style scoped>
.solutions {
  /* min-height: 100vh; */
  background: #ffffff;
}

.container {
  max-width: 1200px;
  margin: 0 auto;
  padding: 20px 0px;
}

.products-header {
  position: relative;
  background-image:
    url('../../assets/background_header/IT业务.png');
    /* linear-gradient(135deg, #0a0e27 0%, #1a1f3a 50%, #0f1419 100%); */
  background-size: cover, 100%;
  background-position: center, center;
  background-blend-mode: overlay;
  padding: 45px 0;
  overflow: hidden;
  min-height: 200px;
  display: flex;
  align-items: center;
}

.products-header .container {
  position: relative;
  z-index: 2;
  width: 100%;
  margin: 0;
  padding: 0 60px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: flex-start;
  gap: 8px;
}

.page-title {
  margin: 0;
  position: relative;
  z-index: 2;
  text-align: left;
  padding: 0;
}

.title-glow {
  display: inline-block;
  font-size: 46px;
  font-weight: 900;
  font-family: 'Arial Black', 'Microsoft YaHei', sans-serif;
  letter-spacing: 5px;
  color: #ffffff;
  filter: drop-shadow(0 0 10px rgba(96, 165, 250, 0.6));
  position: relative;
  backdrop-filter: blur(5px);
}

.page-subtitle {
  margin: 8px 0 0 0;
  text-align: left;
  font-size: 16px;
  color: rgba(255, 255, 255, 0.8);
  font-style: italic;
  line-height: 1.8;
  opacity: 1;
  max-width: 900px;
  margin-left: 2em;
  position: relative;
  z-index: 2;
  backdrop-filter: blur(5px);
}

.content-section {
  background: #f6f8fb;
  padding: 40px 0;
}

.tab-panel {
  background: #ffffff;
  padding: 40px;
  box-shadow: 0 20px 40px rgba(15, 29, 64, 0.08);
}

.it-section {
  margin-bottom: 32px;
}

.it-section-title {
  position: relative;
  margin: 0 0 20px;
  font-size: 24px;
  font-weight: 600;
  color: #1a1a1a;
  padding-left: 15px;
}

.it-section-title::before {
  content: '';
  position: absolute;
  left: 0;
  top: 0;
  bottom: 0;
  width: 5px;
  background: linear-gradient(180deg, #4c95e3 0%, #1e55a2 100%);
  border-radius: 0 2px 2px 0;
}

.it-section-title--sub {
  margin-top: 40px;
}

.services-list {
  display: grid;
  gap: 24px;
}

.services-list--three {
  grid-template-columns: repeat(3, minmax(0, 1fr));
}

.services-list--two {
  grid-template-columns: repeat(2, minmax(0, 1fr));
}

.it-card {
  display: flex;
  flex-direction: column;
  background: #ffffff;
  border-radius: 12px;
  overflow: hidden;
  text-decoration: none;
  color: inherit;
  box-shadow: 0 8px 24px rgba(15, 29, 64, 0.08);
  transition: transform 0.2s ease, box-shadow 0.2s ease;
  cursor: pointer;
}

.it-card:hover {
  transform: translateY(-6px);
  box-shadow: 0 14px 30px rgba(15, 29, 64, 0.12);
}

.it-card-image {
  height: 200px;
  background-size: cover;
  background-position: center;
}

.it-card-body {
  padding: 20px 24px 22px;
}

.it-card-title {
  margin: 0 0 6px;
  font-size: 18px;
  font-weight: 600;
  color: #1a1a1a;
}

.it-card-desc {
  margin: 0;
  font-size: 14px;
  color: #5f6472;
  line-height: 1.7;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
}

@keyframes gradient-shift {
  0%,
  100% {
    background-position: 0% center;
  }
  50% {
    background-position: 100% center;
  }
}

.loading-container,
.error-container {
  text-align: center;
  padding: 60px 20px;
  color: #666;
}

.error-container {
  color: #e74c3c;
}

@media (max-width: 768px) {
  .products-header {
    padding: 80px 0 60px;
  }

  .title-glow {
    font-size: 42px;
  }

  .tab-panel {
    padding: 24px;
  }

  .services-list,
  .services-list--three,
  .services-list--two {
    grid-template-columns: repeat(1, minmax(0, 1fr));
    gap: 20px;
  }
}
</style>

